import { SidebarItemType } from "@/constants/constant";
import { routePermissions } from "@/constants/permissionMap";
import { SidebarContentProps } from "@/types/index.type";
import {
  Users2,
  FolderTree,
  Settings,
  Mail,
  Newspaper,
  Phone,
  ShoppingCart,
  Percent,
  CreditCard,
  Handshake,
  Wallpaper,
  Mailbox,
  BadgePercent,
  // ShieldCheck,
  UserRoundCog,
  ShieldUser,
  CircleUserRound,
  Gift,
  BadgeCheck,
  Clock,
  ChartArea,
  BadgeX,
  Ban,
  ListTodo,
  Container,
  Bell,
  Truck,
  PackageCheck,
  Store,
  FileText,
  Link2
} from "lucide-react";

export const sidebarContent: SidebarContentProps[] = [
  {
    type: SidebarItemType.CONTENT,
    item: {
      type: SidebarItemType.GROUP,
      items: [
        {
          type: SidebarItemType.COLLAPSE_MENU,
          title: "main",
          items: [
            {
              type: SidebarItemType.NORMAL_ITEM,
              Icon: ChartArea,
              title: "statistics",
              path: "statistics",
              requiredPermissions: routePermissions.dashboard.list
            },
            {
              type: SidebarItemType.COLLAPSE_ITEM,
              Icon: ShieldUser,
              childPaths: ["permissions", "roles", "users"],
              title: "users_management",
              items: [
                {
                  title: "users",
                  type: SidebarItemType.SUB_MENU,
                  items: [
                    {
                      type: SidebarItemType.SUB_ITEM,
                      title: "users",
                      Icon: CircleUserRound,
                      path: "users",
                      requiredPermissions: routePermissions.users.list
                    },
                    {
                      type: SidebarItemType.SUB_ITEM,
                      title: "roles",
                      Icon: UserRoundCog,
                      path: "roles",
                      requiredPermissions: routePermissions.superAdmin.all
                    },
                    // {
                    //   type: SidebarItemType.SUB_ITEM,
                    //   title: "permissions",
                    //   Icon: ShieldCheck,
                    //   path: "permissions",
                    //   requiredPermissions: routePermissions.superAdmin.all
                    // },
                  ],
                },
              ],
            },
            {
              type: SidebarItemType.COLLAPSE_ITEM,
              Icon: Gift,
              childPaths: ["products"],
              title: "products_management",
              items: [
                {
                  title: "products",
                  type: SidebarItemType.SUB_MENU,
                  items: [
                    {
                      type: SidebarItemType.SUB_ITEM,
                      Icon: Gift,
                      title: "products",
                      path: "products",
                      requiredPermissions: routePermissions.products.list
                    },
                    {
                      type: SidebarItemType.SUB_ITEM,
                      Icon: Container,
                      title: "storehouse",
                      path: "storehouse",
                      requiredPermissions: routePermissions.products.list
                    },
                    {
                      type: SidebarItemType.SUB_ITEM,
                      Icon: FolderTree,
                      title: "categories",
                      path: "categories",
                      requiredPermissions: routePermissions.categories.list
                    },
                    {
                      type: SidebarItemType.SUB_ITEM,
                      Icon: Settings,
                      title: "features",
                      path: "features",
                      requiredPermissions: routePermissions.features.list
                    },
                    {
                      type: SidebarItemType.SUB_ITEM,
                      Icon: Percent,
                      title: "offers",
                      path: "offers",
                      requiredPermissions: routePermissions.offers.list
                    },
                    {
                      type: SidebarItemType.SUB_ITEM,
                      Icon: BadgePercent,
                      title: "coupons",
                      path: "coupons",
                      requiredPermissions: routePermissions.coupons.list
                    },
                  ],
                },
              ],
            },
            {
              type: SidebarItemType.COLLAPSE_ITEM,
              Icon: ShoppingCart,
              childPaths: ["requests", "accepted", "rejected", "canceled","ontheway","delivered"],
              title: "orders",
              items: [
                {
                  title: "orders",
                  type: SidebarItemType.SUB_MENU,
                  items: [
                    {
                      type: SidebarItemType.SUB_ITEM,
                      Icon: Clock,
                      title: "requests",
                      path: "requests",
                      requiredPermissions: routePermissions.carts.list
                    },
                    {
                      type: SidebarItemType.SUB_ITEM,
                      Icon: BadgeCheck,
                      title: "accepted",
                      path: "accepted",
                      requiredPermissions: routePermissions.cartTracking.list
                    },
                    {
                      type: SidebarItemType.SUB_ITEM,
                      Icon: BadgeX,
                      title: "rejected",
                      path: "rejected",
                      requiredPermissions: routePermissions.carts.list
                    },
                    {
                      type: SidebarItemType.SUB_ITEM,
                      Icon: Ban,
                      title: "canceled",
                      path: "canceled",
                      requiredPermissions: routePermissions.carts.list
                    },
                    {
                      type: SidebarItemType.SUB_ITEM,
                      Icon: Truck,
                      title: "On The way",
                      path: "ontheway",
                      requiredPermissions: routePermissions.carts.list
                    },
                    {
                      type: SidebarItemType.SUB_ITEM,
                      Icon: PackageCheck,
                      title: "Delivered",
                      path: "delivered",
                      requiredPermissions: routePermissions.carts.list
                    },
                  ],
                },
              ],
            },
            {
              type: SidebarItemType.NORMAL_ITEM,
              Icon: Users2,
              title: "customers",
              path: "customers",
              requiredPermissions: routePermissions.customers.list
            },
            {
              type: SidebarItemType.NORMAL_ITEM,
              Icon: Handshake,
              title: "clients",
              path: "clients",
              requiredPermissions: routePermissions.companyCustomers.list
            },
            {
              type: SidebarItemType.COLLAPSE_ITEM,
              Icon: Store,
              childPaths: ["distributors", "distributor-applications"],
              title: "distributors",
              items: [
                {
                  title: "distributors",
                  type: SidebarItemType.SUB_MENU,
                  items: [
                    {
                      type: SidebarItemType.SUB_ITEM,
                      Icon: Store,
                      title: "distributors_list",
                      path: "distributors",
                    },
                    {
                      type: SidebarItemType.SUB_ITEM,
                      Icon: FileText,
                      title: "applications",
                      path: "distributor-applications",
                    },
                  ],
                },
              ],
            },
            {
              type: SidebarItemType.NORMAL_ITEM,
              Icon: Newspaper,
              title: "blogs",
              path: "blogs",
              requiredPermissions: routePermissions.blogs.list
            },
            {
              type: SidebarItemType.NORMAL_ITEM,
              Icon: Bell,
              title: "notifications",
              path: "notifications",
            },
            {
              type: SidebarItemType.NORMAL_ITEM,
              Icon: CreditCard,
              title: "payment_methods",
              path: "payment-methods",
              requiredPermissions: routePermissions.paymentMethods.list
            },
            {
              type: SidebarItemType.NORMAL_ITEM,
              Icon: ListTodo,
              title: "tickets",
              path: "tickets"
            },
            {
              type: SidebarItemType.NORMAL_ITEM,
              Icon: Wallpaper,
              title: "sliders",
              path: "sliders",
              requiredPermissions: routePermissions.sliders.list
            },
            {
              type: SidebarItemType.NORMAL_ITEM,
              Icon: Wallpaper,
              title: "banners",
              path: "banners",
              requiredPermissions: routePermissions.banners.create
            },
            {
              type: SidebarItemType.NORMAL_ITEM,
              Icon: Mailbox,
              title: "newsletter_subscriptions",
              path: "newsletter-subscriptions",
            },
            {
              type: SidebarItemType.NORMAL_ITEM,
              Icon: Phone,
              title: "contact_requests",
              path: "contact-requests",
              requiredPermissions: routePermissions.contacts.list
            },
            {
              type: SidebarItemType.NORMAL_ITEM,
              Icon: Mail,
              title: "special_requests",
              path: "special-requests",
              requiredPermissions: routePermissions.specialRequests.list
            },
            {
              type: SidebarItemType.NORMAL_ITEM,
              Icon: Link2,
              title: "payment_links",
              path: "payment-links",
              requiredPermissions: routePermissions.paymentLinks.list
            },
            {
              type: SidebarItemType.NORMAL_ITEM,
              Icon: Settings,
              title: "company_information",
              path: "company-info",
            },
          ],
        },
      ],
    },
  },
];
